import React from "react";

import useApi from "../../../../hooks/useApi";
import env from "@beam-australia/react-env";

import { useForm, Controller } from "react-hook-form";
import { useTranslation } from "react-i18next";
import useSkeleton from "../../../../hooks/useSkeleton";

import { InputNumber } from "primereact/inputnumber";
import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

import "react-toastify/dist/ReactToastify.css";

import { useAtom } from "jotai";
import { loadingState } from "../../../../states/loadingState";
import { creditIdState } from "../../../../states/creditIdState";
import { toastState } from "../../../../states/toastState";

const ManualPayment = () => {
  const api = useApi();

  const [isLoading, setIsLoading] = useAtom(loadingState);

  const [toastConfig, setToastConfig] = useAtom(toastState);

  const creditId = useAtom(creditIdState);

  const s = useSkeleton("abm");
  const { t } = useTranslation();

  const {
    control,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      amount: 0,
    },
  });

  const onSubmit = async (data) => {
    setIsLoading(true);

    try {
      console.log("creditId", creditId);
      const response = await api.post(`${env("API_URL")}/credits/payment`, {
        creditId,
        amount: data.amount,
      });
      setToastConfig({
        severity: "success",
        summary: t("forms.messages.titles.success"),
        detail: t("forms.messages.operation.success"),
        life: 3000,
        visible: true,
      });
    } catch (error) {
      setToastConfig({
        severity: "error",
        summary: "Error",
        detail: t("errors.general"),
        life: 3000,
        visible: true,
      });
    }

    setIsLoading(false);
  };

  const getFormErrorMessage = (error) => {
    return error && <small className="p-error">{error.message}</small>;
  };

  return (
    <React.Fragment>
      <div className={s.get()}>
        <form
          onSubmit={handleSubmit(onSubmit)}
          className="flex justify-content-between w-full gap-3 "
        >
          <Controller
            name="amount"
            control={control}
            rules={{
              min: {
                value: 1,
                message: t("forms.validation.min", {
                  entity: t("amount"),
                  min: 1,
                }),
              },
              max: {
                value: 200000,
                message: t("forms.validation.max", {
                  entity: t("amount"),
                  max: 200000,
                }),
              },
            }}
            render={({ field }) => (
              <div className={s.get("form.field")}>
                <div className={s.get("form.field.label")}>
                  <label htmlFor="amount">
                    {t("entities.payments.amount")}
                  </label>
                </div>
                <div className={s.get("form.field.value")}>
                  <div className={s.get("form.field.value.error")}>
                    {getFormErrorMessage(errors.annualRate)}
                  </div>
                  <div className={`${s.get("form.field.value.control")} `}>
                    <div className="flex  gap-2">
                      <div>
                        <InputNumber
                          id={field.name}
                          value={field.value ?? ""}
                          onValueChange={(e) => field.onChange(e.value)}
                          mode="decimal"
                          locale="de-DE"
                          maxFractionDigits={2}
                          minFractionDigits={2}
                          inputClassName={[
                            classNames({
                              "p-invalid": errors.annualRate,
                            }),
                          ]}
                          onFocus={(e) => e.target.select()}
                          className="w-10rem"
                        />
                      </div>
                      <div>
                        <Button
                          label={isLoading ? "Wait" : "Pagar"}
                          icon="pi pi-check"
                          className=" btn btn-primary btn-primary-crud"
                          type="submit"
                          disabled={isLoading}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          />
        </form>
      </div>
    </React.Fragment>
  );
};

export default ManualPayment;
